
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content/feeds/prepare/3",
      function () {
        return require("private-next-pages/content/feeds/prepare/3.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/content/feeds/prepare/3"])
      });
    }
  